import React, { useEffect } from "react";

import { userManager } from "@/utils";

const Login: React.FC = () => {
  useEffect(() => {
    userManager.signinRedirect();
  }, []);

  return (
    <div className="public-page-container">
      <p className="tw:text-center tw:font-medium" style={{ color: "#172B4D" }}>
        در حال بارگذاری لطفا کمی صبر کنید...
      </p>
    </div>
  );
};

// Inject the Params provided by React Router into connected components
export default Login;
